import { TestType } from '../../types/test';
import { TESTS } from '../../utils/constants';

interface FooterProps {
  selectedTest: TestType;
  isPaused: boolean;
}

export function Footer({ selectedTest, isPaused }: FooterProps) {
  const currentTest = TESTS.find((t) => t.id === selectedTest);

  return (
    <footer
      className="fixed bottom-0 left-0 right-0 h-[38px] flex items-center justify-between px-5 z-40"
      style={{
        background: 'rgba(10, 10, 15, 0.85)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(255,255,255,0.05)',
      }}
    >
      <div className="flex items-center gap-3">
        <span className="text-xs text-white/30">
          {currentTest?.icon}{' '}
          <span className="text-white/70 font-medium">{currentTest?.name}</span>
        </span>
        {isPaused && (
          <span className="text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full"
            style={{ background: 'rgba(250, 204, 21, 0.12)', color: 'rgba(250, 204, 21, 0.8)', border: '1px solid rgba(250, 204, 21, 0.2)' }}>
            Paused
          </span>
        )}
      </div>

      <div className="flex items-center gap-4 text-[11px] text-white/20">
        {[
          { key: '1–9', label: 'Switch' },
          { key: 'F', label: 'Fullscreen' },
          { key: 'Space', label: 'Pause' },
          { key: '←→', label: 'Navigate' },
          { key: '?', label: 'Help' },
        ].map(({ key, label }) => (
          <span key={key} className="hidden sm:flex items-center gap-1">
            <kbd className="px-1.5 py-0.5 rounded-md text-white/40 font-mono text-[10px]"
              style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.08)' }}>
              {key}
            </kbd>
            {label}
          </span>
        ))}
      </div>
    </footer>
  );
}
